import { UNIT_SYSTEM } from '../../../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const columns = (renderValueCell, renderActions, currentUnit, renderDrillFluidCell, wellbore, key) => [
  {
    field: 'row',
    headerName: 'Row#',
    headerAlign: 'center',
    align: 'center',
    width: 70
  },
  {
    field: 'from',
    headerName: `From MD (${wellbore?.from?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 100,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 100,
    renderEditCell: (params) => renderValueCell(key, params),
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(wellbore?.from?.decimals));
    },
  },
  {
    field: 'to',
    headerName: `To MD (${wellbore?.to?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 120,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 120,
    renderEditCell: (params) => renderValueCell(key, params),
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : parseFloat(value.toFixed(wellbore?.to?.decimals));
    },
  },
  {
    field: 'fluid_id',
    headerName: 'Fluid',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 20,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: (params) => renderDrillFluidCell(key, params),
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 70,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => renderActions(key, params),
  }
];
export default columns;
